import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_MDC_STOCK_POSTING_STORAGE_LOCATION } from '../mdc-stock-posting.api';
import { StockPostingStorageLocation } from '../types/storage-location';

@Injectable()
export class StorageLocationRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  load(storageLocationId: number): Promise<StockPostingStorageLocation> {
    return this.dataAccess.get<StockPostingStorageLocation>({
      path: SOFTLINE_API_MDC_STOCK_POSTING_STORAGE_LOCATION,
      pathParams: { id: storageLocationId },
      queryParams: { unit: 'STORAGE' },
    });
  }
}
